const Notify = () => import("Application/modules/configuration/push_notify/views/notify");

export default {
    children: [
        {
            path: "configuration/notify",
            name: "notify",
            component: Notify,
            meta: {
                requiresAuth: true,
                title: "lang.work_orders",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["work_orders.read"],
            },
        },
    ],
};
